<template>
  <div :class="albumClass" v-if="album">
    <router-link :to="{name: 'album-detail', params: {id: album.id}}" class="mb-3">
      <img :src="album.cover">
    </router-link>
    <div class="info">
      <div class="publish-date">
        {{ publishDate }}
      </div>
      <div class="title">
        <router-link :to="{name: 'album-detail', params: {id: album.id}}" class="title-link">
          {{ album.title }}
        </router-link>
      </div>
      <div class="songs">
        {{ songCount }}
      </div>
      <div class="artist" v-if="showArtist">
        By <router-link :to="{name: 'artist-about', params: {artistId: album.artist.id}}">{{ album.artist.name }}</router-link>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .album {
    display: flex;

    img {
      width: 130px;
      height: 130px;
      box-shadow: 1px 2px 7px 0 rgba(0, 0, 0, 0.5);
      margin-right: 20px;
      object-fit: cover;
    }

    &.large {
      img {
        width: 200px;
        height: 200px;
        @include media-breakpoint-down(sm) {
          width: 150px;
          height: 150px;
        }
        @include media-breakpoint-down(xs) {
          width: 100px;
          height: 100px;
        }
      }
    }

    .info {
      .publish-date, .songs, .artist {
        font-size: 0.8em;
        color: $steel;
      }

      .title {
        font-size: 1.2em;
        font-weight: bold;

        .title-link {
          color: white;
        }
      }
    }
  }
</style>

<script>
import moment from '@/utils/moment'

export default {
  name: 'AlbumCard',
  props: {
    album: Object,
    showArtist: Boolean,
    largeCover: Boolean
  },
  computed: {
    albumClass () {
      let cls = ['album']
      if (this.largeCover) cls.push('large')
      return cls
    },
    publishDate () {
      if (!this.album) return ''
      return moment(this.album.release_date).format('MM/DD/YYYY')
    },
    songCount () {
      if (!this.album) return ''
      if (this.album.songs.length === 0) return 'no songs'
      if (this.album.songs.length === 1) return '1 song'
      return this.album.songs.length + ' songs'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/AlbumCard.vue